import PropTypes from 'prop-types';
import { Buttons } from 'lidya-common-components';
import React, { useEffect, useRef } from 'react';
import { Trans } from 'gatsby-plugin-react-i18next';
import { useGlobalData } from '../../../providers/globalDataProvider/globalDataProvider.useGlobalData';

const COMMUNICATION_URL = `${process.env.GATSBY_COMMUNICATION_URL}/request-loan/`;

export function GetExternalLinkButton({
  id, type, className, label, href, onClick: externalClickFunction, target,
}) {
  const { country } = useGlobalData();
  const nHref = href || `${COMMUNICATION_URL}?country_code=${country}`;
  const onClick = useRef(() => {});

  useEffect(() => {
    onClick.current = () => {
      externalClickFunction();
      const aElement = document.createElement('a');
      aElement.href = nHref;
      aElement.target = target;
      document.body.appendChild(aElement);
      aElement.click();
      document.body.removeChild(aElement);
    };

    return () => {};
  }, [externalClickFunction, nHref, target]);

  return (
    <Buttons.Button className={className} id={`GetExternalLinkButton${id}`} type={type} onClick={() => onClick.current()}><Trans>{label}</Trans></Buttons.Button>
  );
}

GetExternalLinkButton.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string,
  target: PropTypes.oneOf(['_self', '_blank']),
};

GetExternalLinkButton.defaultProps = {
  href: undefined,
  type: Buttons.BUTTON_TYPES.SECONDARY,
  className: undefined,
  label: 'web.navigation.get.loan',
  target: '_blank',
  onClick: () => {},
};

export default GetExternalLinkButton;
